{
  "en": {
    "published": {
      "labels": {
        "publishedCustomerPartners": "Published for customers & partners",
        "publishedCustomer": "Published for customers",
        "publishedPartners": "Published for partners",
        "notPublished": "Not published"
      },
      "publish_mode": {
        "inherit": "Follow template",
        "inherit_info": "Keep each item's published or unpublished state from the template",
        "publish": "Publish to customers",
        "publish_info": "Customers can see these right away",
        "title": "Publishing",
        "unpublished": "Create without publishing",
        "unpublished_info": "Hidden from customers until you publish them"
      }
    }
  }
}
